/**
 * @generated SignedSource<<b7461ee0a5271a9012c2b4b8bcd123ae>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SnsAssociation$data = {
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"SnsAssociationTiktok" | "SnsAssociationYoutube">;
  readonly " $fragmentType": "SnsAssociation";
};
export type SnsAssociation$key = {
  readonly " $data"?: SnsAssociation$data;
  readonly " $fragmentSpreads": FragmentRefs<"SnsAssociation">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SnsAssociation",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SnsAssociationTiktok"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SnsAssociationYoutube"
    }
  ],
  "type": "Influencer",
  "abstractKey": null
};

(node as any).hash = "10565af8dcf2d61585fe5f4d386b0094";

export default node;
